import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import SpogButton from 'components/ui/form/SpogButton';
import SpogModal from 'components/ui/layout/panel/SpogModal';
import CookiesManager from 'components/notifications/CookiesManager';
import ReactGA from 'react-ga';
import {GOOGLE_ANALYTICS_ID} from 'config';

import {manageCookies} from 'modules/cookiesManager';
import {GOOGLE_ANALYTICS_COOKIES} from 'util/cookies';

import 'style/components/notification/cookie-manager.scss';


const GOOGLE_ANALYTICS = 'googleAnalytics';
const MANDATORY_COOKIES = 'mandatoryCookies';

class ManagePermissions extends Component {

    static propTypes = {
        permission: PropTypes.string, // Tag with the name of the permission
        label:      PropTypes.string, // Label with the name of the permission
        onChange:   PropTypes.func, // Function to call when value change
        disabled:   PropTypes.bool, // true if the switch is disabled
        value:      PropTypes.bool // Initial value
    };


    state = {
        isManagePermissonsOpen: false,
        mandatoryCookies:       true
    };

    /**
     * Set this to handlers
     */
    componentWillMount() {
        const {cookiesManager} = this.props;

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnAcceptCookiesModal = this.handleOnAcceptCookiesModal.bind(this);

        this.setState({
            ...this.state,
            googleAnalytics: cookiesManager.googleAnalytics
        });
    }

    handleOpenModal() {
        this.setState({
            ...this.state,
            isManagePermissonsOpen: true
        });
    }

    handleCloseModal() {
        const {googleAnalytics} = this.state;

        document.cookie = `_gat=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        document.cookie = `_ga=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        document.cookie = `_gid=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        document.cookie = `_gat=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        document.cookie = `_ga=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        document.cookie = `_gid=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

        if (googleAnalytics === false) {
            window[`ga-disable-${GOOGLE_ANALYTICS_ID}`] = true;
            GOOGLE_ANALYTICS_COOKIES.forEach(cookie => {
                document.cookie = `${cookie}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
            });
        } else {
            ReactGA.initialize(GOOGLE_ANALYTICS_ID);
            ReactGA.pageview('/profile');
        }
        this.setState({
            ...this.state,
            isManagePermissonsOpen: false
        });
    }


    handleOnChange(permission, value) {
        this.setState({
            ...this.state,
            [permission]: value
        });
    }

    handleOnAcceptCookiesModal() {
        const {dispatch} = this.props;
        const {googleAnalytics, mandatoryCookies} = this.state;

        dispatch(manageCookies({googleAnalytics, mandatoryCookies}));

        this.handleCloseModal();
    }

    render() {
        const {intl: {formatMessage}} = this.props;
        const {isManagePermissonsOpen, googleAnalytics} = this.state;


        return (
            <span>
                <SpogButton
                    text={formatMessage({id: 'title.google.handlePermissions'})}
                    onClick={this.handleOpenModal}
                    className={'open-modal'}
                    noBorders
                />
                <SpogModal
                    showModal={isManagePermissonsOpen}
                    title={formatMessage({id: 'title.google.handlePermissions'})}
                    closeText={formatMessage({id: 'label.close'})}
                    acceptText={formatMessage({id: 'label.accept'})}
                    showAccept
                    acceptConfirm
                    onAccept={this.handleOnAcceptCookiesModal}
                    onClose={this.handleCloseModal}
                >
                    <CookiesManager
                        permission={GOOGLE_ANALYTICS}
                        label={'googleAnalyticsLabel'}
                        onChange={this.handleOnChange}
                        value={googleAnalytics}
                        description={'googleAnalyticsDescription'}
                    />
                    <CookiesManager
                        permission={MANDATORY_COOKIES}
                        label={'mandatoryCookiesLabel'}
                        onChange={this.handleOnChange}
                        value={true}
                        disabled
                        description={'mandatoryCookiesDescription'}
                    />
                </SpogModal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    cookiesManager: state.cookiesManager
});

export default withRouter(injectIntl(connect(mapStateToProps)(ManagePermissions)));



// WEBPACK FOOTER //
// ./src/components/notifications/ManagePermissions.jsx